import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";

const useSiteLogo = () => useAppContext().brandLogos.icon;

export default useSiteLogo;
